<ng-template #descTemplate>
  <span class="text-muted">
      <span class="item-list-project-title">
        <span [innerHTML]="dsoNameService.getName(mdRepresentation, true)"></span>
      </span>
  </span>
</ng-template>
<ds-truncatable [id]="mdRepresentation.id">
  <a [routerLink]="[itemPageRoute]"
     [innerHTML]="dsoNameService.getName(mdRepresentation, true)"
     [ngbTooltip]="dsoNameService.getName(mdRepresentation, true).length > 0 ? descTemplate : null"></a>
</ds-truncatable>
